import { isNil } from 'lodash';
import { CommunicationStatusLabelsMap } from 'constants/common';
import { CurrencyRates } from 'types';
import { CampaignAwardDetailsResponseDTO, CampaignAwardDetailsUIModel } from './types';

export const parseCampaignAwardDetailsToUIModel = (
    apiModel: CampaignAwardDetailsResponseDTO,
    currencyRates: CurrencyRates,
    userCurrencyId: string,
): CampaignAwardDetailsUIModel => {
    let totalAmountInUserCurrency: number | null = null;
    const parsedListData = apiModel.SucceededByCurrency.map(({ CurrencyId, Count, Amount }) => {
        const rate = currencyRates[userCurrencyId]?.[CurrencyId]?.Rate;
        const amountInUserCurrency = isNil(rate) ? null : Amount * (rate || 0);

        if (!isNil(amountInUserCurrency)) {
            totalAmountInUserCurrency = (totalAmountInUserCurrency ?? 0) + (amountInUserCurrency ?? 0);
        }

        return {
            hasHover: true,
            dragDisable: true,
            data: {
                index: CurrencyId,
                CurrencyId,
                Count: Count,
                Amount: Amount,
                AmountInUserCurrency: amountInUserCurrency,
            },
        };
    });

    const parsedTotalsData = apiModel.CountByStatus.map(({ Status, Count }) => ({
        labelKey: CommunicationStatusLabelsMap[Status],
        value: Count,
    }));

    return {
        tableData: parsedListData,
        totalsData: { countsByStatuses: parsedTotalsData, totalAmountInUserCurrency },
    };
};
